export enum LinkedItemParentTable {
  COACHLOG = 'egrowe_coachlog',
  IMPLEMENTATION_PLAN = 'implementation_plan',
  PD_SESSION = 'pd_session',
  USER = 'user',
  SCHOOL = 'school',
}

export enum LinkedItemSearchSource {
  COACHLOG = 'coachlog',
  IMPLEMENTATION_PLAN = 'implementation_plan',
  PD_SESSION = 'pd_session',
  USER = 'user',
  SCHOOL = 'school',
}

export enum LinkedItemTargetTable {
  COACHLOG = 'egrowe_coachlog',
  PLAN = 'implementation_plan',
  PLAN_PHASE = 'implementation_phase',
  PLAN_DELIVERABLE = 'implementation_deliverable',
  PLAN_ACTION_ITEM = 'implementation_action_item',
  PD_SESSION = 'pd_session',
}

export enum LinkedItemParentTableType {
  COACHING_CONVERSATION = 'egrowe-coachlog-v2',
  OBSERVATION = 'observation',
  CLASSROOM_VISIT = 'classroom-visit',
  GENERAL_LOG = 'general-log',
  UNIVERSAL_LOG = 'universal-log',
  MICROLEARNING = 'microlearning',
  WORKSHOP = 'workshop',
  WEBINAR = 'webinar',
}

// Linked Items
export interface LinkedItemAPIResponse {
  id: number;
  parent_table: LinkedItemParentTable;
  parent_table_type: LinkedItemParentTableType | null;
  parent_table_type_label?: string | null;
  parent_start_datetime?: number;
  parent_end_datetime?: number;
  parent_id: number;
  link_icon: string;
  link_title: string;
  link_url?: string;
  target_table: string;
  target_id: number;
}

// Search
export interface LinkedItemSearchOption {
  parent_table: LinkedItemParentTable;
  parent_table_type: LinkedItemParentTableType | null;
  parent_table_type_label?: string | null;
  parent_start_datetime?: number;
  parent_end_datetime?: number;
  parent_id: number;
  link_icon: string;
  link_title: string;
  link_url?: string;
}

export interface LinkedItemSearchItemAPIResponse {
  parent_table: string;
  parent_id: number;
  parent_table_type: LinkedItemParentTableType | null;
  parent_table_type_label?: string | null;
  title: string;
  district_id: number | null;
  updated_at: number | null;
  start_datetime: number | null;
  end_datetime?: number | null;
}

export interface LinkedItemsSearchAPIResponse {
  items?: LinkedItemSearchItemAPIResponse[];
  district_id: number;
  search: string;
  sources?: LinkedItemSearchSource[];
}
